import { inject, Injectable, Injector, OnDestroy } from '@angular/core';
import { Data, Router } from '@angular/router';
import { AuthService } from '@core/auth.service';
import { Observable, of, Subject, switchMap } from 'rxjs';
import { CommonVariable } from 'src/app/app.constants';
import { v4 as uuidv4 } from "uuid";
import { CommonService } from '../../common/common.service';

@Injectable({
  providedIn: 'root'
})
export class RequestProfileService implements OnDestroy {
  private destroy$ = new Subject<void>();
  preferredCurrency: string;
  public checkApiPostReqProfileImg;
  public checkApiPostReqRemovePhoto;
  private commonService = inject(CommonService)

  constructor(private router: Router, private injector: Injector) {
    this.checkApiPostReqProfileImg = false;
    this.checkApiPostReqRemovePhoto = false;
    this.preferredCurrency = "GBP";
  }


  // This function is used to get the request body for to validate request is validate or not
  private validateRequest(): boolean {
    return true;
  }
  // This function is used to update user profile with facebook profile details
  userFacebookProfileUpdate(profileDataControls) {
    if (this.validateRequest()) {
      const authService = this.injector.get(AuthService);
      return authService.getUid$("RequestProfileService").pipe(
        switchMap(async (userId) => {
          if (!userId) userId = null;
          return {
            modules: [
              {
                document: "/api_post_request/update_customer_details",
                email: profileDataControls?.email,
                module_name: "update_customer_details",
                name: profileDataControls?.name,
                requestid: uuidv4(),
                surname: profileDataControls?.surname,
                user_id: userId,
              },
            ],
          };
        }));
    }
  }
  // This function is used to get the request body to update user profile image and update with facebook photoUrl
  updateProfileImageFromFacebook(imageUrl: string) {
    if (this.validateRequest()) {
      const authService = this.injector.get(AuthService);
      return authService.getUid$("RequestProfileService").pipe(
        switchMap(async (userId) => {
          if (!userId) {
            return of(null);
          }
          return {
            modules: [
              {
                module_name: "update_customer_profile_image",
                user_id: userId,
                profile_image_url: imageUrl,
                requestid: uuidv4(),
                document: "/api_post_request/update_customer_details",
              },
            ],
          };
        }));
    }
  }
  // This function is used to get the request body for to update user profile with all profile details
  getUserProfileUpdateRequest(profileDataControls, expectedUserId?: string) {
    if (!this.validateRequest()) {
      return of(null);
    }
    return new Observable((observer) => {
      this.commonService.getUid('RequestProfileService').subscribe({
        next: (userId) => {
          if (!userId || (expectedUserId && userId !== expectedUserId)) {
            observer.next(null);
            observer.complete();
            return;
          }
          observer.next({
            modules: [
              {
                module_name: 'update_customer_details',
                address_1: profileDataControls?.address_1?.value || null,
                address_2: profileDataControls?.address_2?.value || null,
                date_of_birth: profileDataControls.date_of_birth.value,
                email: profileDataControls.email.value,
                name: profileDataControls.name.value,
                surname: profileDataControls.surname.value,
                postal_code: profileDataControls?.postal_code?.value || null,
                town: profileDataControls?.town?.value || null,
                profile_nickname:
                  profileDataControls?.profile_nickname?.value || null,
                user_id: userId,
                preferred_currency:
                  profileDataControls?.currency?.value ||
                  localStorage.getItem('user_currency') ||
                  'GBP',
                language_code:
                  profileDataControls?.currentLanguage?.value ||
                  localStorage.getItem('language_code') ||
                  'en',
                requestid: uuidv4(),
                document: '/api_post_request/update_customer_details',
                title: profileDataControls?.option?.value || 'Mr',
              },
            ],
          });

          observer.complete();
        },
        error: () => {
          observer.next(null);
          observer.complete();
        },
      });
    });
  }


  // This function is used to get the request body for to update user profile image
  updateProfileImage(imageUrl: any) {
    if (this.validateRequest()) {
      const authService = this.injector.get(AuthService);
      return authService.getUid$("RequestProfileService").pipe(
        switchMap(async (userId) => {
          if (!userId) {
            return of(null);
          }
          return {
            modules: [
              {
                module_name: "update_customer_profile_image",
                user_id: userId,
                profile_image_url: imageUrl,
                requestid: uuidv4(),
                document: this.checkApiPostReqRemovePhoto ? "/api_post_request/remove_customer_profile_image" : "",
              },
            ],
          };
        }));
    }
  }
  // This function is used to get the request body for update user's nick name
  getUserNicknameUpdateRequest(nickname) {
    if (this.validateRequest()) {
      const authService = this.injector.get(AuthService);
      return authService.getUid$("RequestProfileService").pipe(
        switchMap(async (userId) => {
          if (!userId) {
            return of(null);
          }
          return {
            modules: [
              {
                module_name: "update_nick_name",
                user_id: userId,
                param: {
                  nick_name: nickname,
                },
              },
            ],
          };
        }));
    }
  }
  // This function is used to get the request body for get wp page contents for account module.  [this function is not call anywhere so comment it ]
  getPolicyInformationRequest(contentType: string) {
    const authService = this.injector.get(AuthService);
    return authService.getUid$("RequestProfileService").pipe(
      switchMap(async (userId) => {
        if (!userId) {
          return of(null);
        }
        return {
          modules: [
            {
              page_id: 1,
              screen_id: 1,
              module_name: "get_wp_page_contents",
              page_name: contentType,
            },
          ],
          collection: `/users/${userId}/account_module`,
          mapKey: "page_name",
        };
      }));
  }
  // This function is used to get the request body for get blog content by passing blog id
  // // This function is used to get the request body for leave private syndicate  [this function is not call anywhere so comment it ]
  getBlogElementDetailRequest(eventId) {
    if (this.validateRequest()) {
      return {
        request: [
          {
            session_ID: "CommonService.session.session_id",
            action: "get_blog_contents",
            website: "Lotto Social",
            website_id: "33",
            source_site: "mobi.lottosocial.com",
            page_id: "1",
            screen_id: "1.6.3",
            module_name: "get_blog_contents",
            blog_id: eventId,
          },
        ],
      };
    }
  }

  // This function is used to get the request body for get donate for charity  [this function is not call anywhere so comment it ]
  getDonateForCharityRequest(awaridId, charityPoints) {
    if (this.validateRequest()) {
      const authService = this.injector.get(AuthService);
      authService.getUid$("RequestProfileService").pipe(
        switchMap(async (userId) => {
          if (!userId) {
            return of(null);
          }
          return {
            request: [
              {
                session_ID: "CommonService.session.session_id",
                action: "login_mobile_app",
                website: "Lotto Social",
                website_id: "33",
                source_site: "mobi.lottosocial.com",
                page_id: "3",
                screen_id: "3.7",
                module_name: "reward_payment_process",
                customer_id: userId,
                product_name: "lotto-woggle",
                product_detail:
                  "We hope you've been reading your dictionary as you need to find as many words as possible in the quickest time",
                visitor_id: 852212,
                award_id: awaridId,
                product_count: 1,
                price_per_product: charityPoints,
              },
            ],
          };
        }));
    }
  }

  // This function is used to get the request body for activate game booster for user using customer award id  [this function is not call anywhere so comment it ]
  getActiveBoosterRequest(customerAwardId) {
    if (this.validateRequest()) {
      const authService = this.injector.get(AuthService);
      authService.getUid$("RequestProfileService").pipe(
        switchMap(async (userId) => {
          if (!userId) {
            return of(null);
          }
          return {
            request: [
              {
                screen_id: "3.1",
                action: "play_game",
                module_name: "activate_game_booster",
                customer_id: userId,
                customer_award_log_id: customerAwardId,
              },
            ],
          };
        }));
    }
  }

  // This function is used to get the request body for get all winnings for the user  [this function is not call anywhere so comment it ]
  getCheckMyWinningsRequest() {
    if (this.validateRequest()) {
      const authService = this.injector.get(AuthService);
      authService.getUid$("RequestProfileService").pipe(
        switchMap(async (userId) => {
          if (!userId) {
            return of(null);
          }
          return {
            request: [
              {
                session_ID: "CommonService.session.session_id",
                page_ID: "9",
                screen_id: "9.2",
                action: "get_win",
                website: "Lotto Social",
                website_id: "33",
                source_site: "mobi.lottosocial.com",
                module_name: "check_mywinnings",
                customer_id: userId,
              },
            ],
          };
        }));
    }
  }

  // This function is used to get the request body for quite the adventure game
  quitAdventureRequest(adventureId: any) {
    const authService = this.injector.get(AuthService);
    return authService.getUid$("RequestProfileService").pipe(
      switchMap(async (userId) => {
        if (!userId) {
          return of(null);
        }
        return {
          modules: [
            {
              module_name: "customer_adventure_game_quit",
              user_id: userId,
              adventure_id: adventureId,
            },
          ],
        };
      }));
  }
  // This function is used to get the request body for get all the issued voucher code for the user
  getVoucherList() {
    if (this.validateRequest()) {
      const authService = this.injector.get(AuthService);
      return authService.getUid$("RequestProfileService").pipe(
        switchMap(async (userId) => {
          if (!userId) {
            return of(null);
          }
          return {
            modules: [
              {
                module_name: "get_issued_voucher_code",
                customer_id: userId,
              },
            ],
            collection: `/users/${userId}/account_module`,
          };
        }));
    }
  }
  // This function is used to get the request body for update onesignal token in clevertap
  OnesignalNotificationID(onesignalUserId: any) {
    if (!onesignalUserId) return;
    const authService = this.injector.get(AuthService);
    authService.getUid$("RequestProfileService").pipe(
      switchMap(async (userId) => {
        if (!userId) {
          return of(null);
        }
        return {
          modules: [
            {
              module_name: "update_onesignal_token_to_clevertap",
              user_id: userId,
              onesignal_token: onesignalUserId,
              onesignal_token_status: onesignalUserId ? 1 : 0,
            },
          ],
        };
      }));
  }

  // This function is used to get the request body for get customer purchase capping check
  public customer_purchase_capping(customerPurchaseId, prosub_id: string, offer_id) {
    const authService = this.injector.get(AuthService);
    return authService.getUid$("RequestProfileService").pipe(
      switchMap((userId) => {
        if (!userId) {
          console.error('[RequestProfileService] User ID is not available for customer purchase capping');
          return of(null);
        }
        return of({
          modules: [
            {
              user_id: userId,
              customer_purchase_id: customerPurchaseId,
              module_name: "customer_purchase_capping_check",
              prosub_id: prosub_id ? prosub_id : "",
              offer_id: offer_id ? offer_id : "",
              requestid: uuidv4(),
              document: "/api_post_request/customer_purchase_capping_check",
            },
          ],
        });
      }));
  }
  // This function is used to get the request body for to update user profile image moderator
  updateProfileImageModerator(imageUrl: string) {
    if (this.validateRequest()) {
      const authService = this.injector.get(AuthService);
      return authService.getUid$("RequestProfileService").pipe(
        switchMap(async (userId) => {
          if (!userId) {
            return of(null);
          }
          return {
            api_response: {},
            img_url: imageUrl,
            process: false,
            purpose: {
              content: {
                profile_picture: imageUrl,
              },
              destination_document: `/users/${userId}`,
              type: "profile_picture",
            },
            userid: userId,
          };
        }));
    }
  }
  // This function is used to get the request body for to update user cover image moderator
  updateCoverImageModerator(imageUrl: string) {
    const authService = this.injector.get(AuthService);
    return authService.getUid$("RequestProfileService").pipe(
      switchMap(async (userId) => {
        if (!userId) {
          return of(null);
        }
        return {
          api_response: {},
          img_url: imageUrl,
          process: false,
          purpose: {
            content: {
              profile_picture: imageUrl,
            },
            destination_document: `/users/${userId}`,
            type: "cover_picture",
          },
          userid: userId,
        };
      }));
  }
  public inboxMessageHideRequest(data: Data, reason?: string) {
    const authService = this.injector.get(AuthService);
    return authService.getUid$("RequestProfileService").pipe(
      switchMap((userId) => {
        if (!userId) {
          console.error('[RequestProfileService] User ID is not available for inbox message hide request');
          return of(null);
        }
        return of({
          modules: [
            {
              module_name: "issue_customer_awardid",
              user_id: userId,
              award_id: data?.award_id || data?.issue?.award_id,
              inbox_message_id: data?.id ?? null,
              assign_free_play: data?.issue?.assign_free_play ?? null,
              reason: reason || "seasonal_campaign",
              calling_method: "db",
              request_from: "inbox_message_hide",
            },
          ],
        });
      })
    );
  }

  public issueReferralGiftCard(awardId: number, reason?: string) {
    const authService = this.injector.get(AuthService);
    return authService.getUid$("RequestProfileService").pipe(
      switchMap(async (userId) => {
        if (!userId) {
          return of(null);
        }
        return {
          modules: [
            {
              module_name: "issue_customer_awardid",
              user_id: userId,
              award_id: awardId,
              reason: reason || "",
              calling_method: "db",
              request_from: "referral_gift_card",
            },
          ],
        };
      }));
  }

  public freePowerballPushNotification() {
    const authService = this.injector.get(AuthService);
    return authService.getUid$("RequestProfileService").pipe(
      switchMap(async (userId) => {
        if (!userId) {
          return of(null);
        }
        return {
          modules: [
            {
              module_name: "issue_customer_awardid",
              user_id: userId,
              award_id: CommonVariable.freePowerballPushNotificationAwardId,
              reason: CommonVariable.freePowerballPushNotificationReason,
              calling_method: "db",
              request_from: "free_powerball_push_notification",
            },
          ],
        };
      }));
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
